<div class="modal">
    <div class="content-strip" *ngIf="friend">
        <mat-card appearance="outlined" class="card">
            <mat-card-header class="card-header">
                <mat-card-title>Request Already Sent</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="details">
                    <p>A request has already been sent to this user and is still waiting for a response. Would you like
                        to cancel that request?</p>
                </div>
                <div class="buttons">
                    <button mat-button class="large-round spinner center" (click)="goBack(false)">
                        Wait for Response
                    </button>
                    <button mat-button class="large-round spinner center"
                            [disabled]="isCancelFriendRequestInProcess$ | async" (click)="cancelRequest()">
                        Cancel Request

                        <mat-spinner *ngIf="isCancelFriendRequestInProcess$ | async"></mat-spinner>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
